import { createContext, useContext } from "react"

import { useAppSelector } from "@/App"
import { ContextMenu, createContextMenu } from "@/components/ContextMenu"
import { selectPaymentById } from "@/store/payments"
import { Payment } from "@/types"

import { DeletePaymentModal, EditPaymentModal, SetAsTipModal } from "./partials/ActionModals"

export type PaymentContextMenuAction = {
  action: "set_as_tip" | "edit" | "delete"
  paymentId: Payment["id"]
} | null

export const PaymentItemContext = createContext<{
  paymentContextMenuAction: PaymentContextMenuAction
  setPaymentContextMenuAction: (action: PaymentContextMenuAction) => void
} | null>(null)

export const {
  ContextMenuWrapper: PaymentsContextMenuWrapper,
  useContextMenuEvent: usePaymentsContextMenuEvent,
  useContextMenuTrigger: usePaymentsContextMenuTrigger,
} = createContextMenu<{
  paymentId: Payment["id"]
}>("paymentsList")

export const PaymentContextMenu = () => {
  return (
    <>
      <PaymentsContextMenuWrapper>
        <ContextMenuItems />
      </PaymentsContextMenuWrapper>

      <ContextMenuActions />
    </>
  )
}

export const ContextMenuItems = () => {
  const { setPaymentContextMenuAction } = useContext(PaymentItemContext) || {}

  const {
    data: { paymentId },
  } = usePaymentsContextMenuEvent()

  const payment = useAppSelector(selectPaymentById(paymentId))

  if (!payment || !setPaymentContextMenuAction) return null

  return (
    <ContextMenu>
      <ContextMenu.Item
        iconName="sale"
        onClick={() => setPaymentContextMenuAction({ action: "set_as_tip", paymentId })}
      >
        Zalicz jako bonus
      </ContextMenu.Item>

      <ContextMenu.Item iconName="edit" onClick={() => setPaymentContextMenuAction({ action: "edit", paymentId })}>
        Edytuj
      </ContextMenu.Item>

      <ContextMenu.Item
        iconName="close-circle"
        onClick={() => setPaymentContextMenuAction({ action: "delete", paymentId })}
      >
        Usuń
      </ContextMenu.Item>
    </ContextMenu>
  )
}

const ContextMenuActions = () => {
  const { paymentContextMenuAction, setPaymentContextMenuAction } = useContext(PaymentItemContext) || {}

  if (!paymentContextMenuAction || !setPaymentContextMenuAction) return null

  const { action, paymentId } = paymentContextMenuAction

  switch (action) {
    case "set_as_tip":
      return <SetAsTipModal paymentId={paymentId} handleClose={() => setPaymentContextMenuAction(null)} />

    case "edit":
      return <EditPaymentModal paymentId={paymentId} handleClose={() => setPaymentContextMenuAction(null)} />

    case "delete":
      return <DeletePaymentModal paymentId={paymentId} handleClose={() => setPaymentContextMenuAction(null)} />
  }
}
